import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface AddNoteButtonProps {
  onClick: () => void;
}

export function AddNoteButton({ onClick }: AddNoteButtonProps) {
  const { t } = useTranslation("notes");
  return (
    <Button
      size="icon"
      variant="ghost"
      className="h-6 w-6"
      aria-label={t("addButton.ariaLabel")}
      onClick={onClick}
    >
      <Plus className="h-3.5 w-3.5" />
    </Button>
  );
}
